<template>
  <div>
    <div class="flex items-center space-x-4">
      <router-link
        :to="{
          name: isEditing ? 'productCategoriesDetail' : 'productCategoriesIndex',
        }"
        class="system-button"
      >
        <arrow-icon class="w-4 fill-current rotate-90"></arrow-icon>
      </router-link>
      <h2>{{ isEditing ? "Editar" : "Crear" }} Categoría</h2>
    </div>

    <div
      v-if="!loading"
      class="card mt-2"
    >
      <form @submit.prevent="save">
        <div class="flex flex-col w-full">
          <label for="name">Nombre</label>
          <input id="name" type="text" v-model="form.name" @blur="autoSlug" />
          <validation-errors :errors="errorFor('name')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-4">
          <label for="slug">Slug <span class="text-content-300 font-normal text-xs">(URL · solo a-z 0-9 -)</span></label>
          <input id="slug" type="text" v-model="form.slug" placeholder="suplementos" />
          <validation-errors :errors="errorFor('slug')"></validation-errors>
        </div>

        <div class="flex flex-col w-full mt-4">
          <label for="description">Descripción <span class="text-content-300 font-normal text-xs">(visible en la PLP de la categoría)</span></label>
          <textarea id="description" v-model="form.description" rows="3"></textarea>
          <validation-errors :errors="errorFor('description')"></validation-errors>
        </div>

        <div class="flex flex-col sm:flex-row sm:space-x-4 mt-4">
          <div class="flex flex-col flex-1">
            <label for="position">Orden</label>
            <input id="position" type="number" min="0" v-model.number="form.position" />
            <validation-errors :errors="errorFor('position')"></validation-errors>
          </div>
          <div class="flex items-center mt-6 sm:mt-0">
            <label class="inline-flex items-center cursor-pointer">
              <input type="checkbox" v-model="form.is_published" class="mr-2" />
              <span>Publicada (visible en la tienda)</span>
            </label>
          </div>
        </div>

        <primary-button type="submit" class="mt-6 mx-0" :loading="loadingForm"
          >{{ isEditing ? "Guardar" : "Crear" }}
        </primary-button>
      </form>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
export default {
  name: "Product Category Form",

  data() {
    return {
      form: {
        name: "",
        slug: "",
        description: "",
        position: 0,
        is_published: false,
      },
      loading: false,
      loadingForm: false,
      isEditing: false,
      permissions: null,
    };
  },

  created() {
    this.$store.commit("setStoreSelectedTab", "productCategories");

    if (this.$route.params.id) {
      this.isEditing = true;
      this.loadCategory();
    }
  },

  mixins: [validationErrors],

  methods: {
    async loadCategory() {
      this.loading = true;

      try {
        const response = await api.productCategories.getById(
          this.$route.params.id
        );

        this.form = await JSON.parse(JSON.stringify(response));
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    save() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      if (!this.isEditing) {
        this.createCategory();
      } else {
        this.updateProductCategories();
      }
    },

    validateForm() {
      this.errors = {};

      if (!this.form.name) {
        this.errors["name"] = ["Campo requerido"];
      }

      if (this.form.slug && !/^[a-z0-9-]+$/.test(this.form.slug)) {
        this.errors["slug"] = ["Solo letras minúsculas, números y guiones."];
      }

      return Object.keys(this.errors).length === 0;
    },

    autoSlug() {
      if (this.form.slug) return;
      this.form.slug = (this.form.name || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .replace(/[^a-z0-9\s-]/g, "")
        .trim()
        .replace(/\s+/g, "-");
    },

    async createCategory() {
      this.loadingForm = true;

      try {
        const response = await api.productCategories.create(this.form);
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "productCategoriesIndex" });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },

    async updateProductCategories() {
      this.loadingForm = true;

      try {
        const response = await api.productCategories.update(
          this.$route.params.id,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "productCategoriesIndex" });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },
};
</script>